/**
 * Convert any Google Drive URL into a direct-serving lh3.googleusercontent.com link.
 *
 * Accepted input formats:
 *   - https://drive.google.com/file/d/FILE_ID/view?usp=sharing
 *   - https://drive.google.com/open?id=FILE_ID
 *   - https://drive.google.com/uc?export=view&id=FILE_ID
 *   - https://docs.google.com/uc?id=FILE_ID
 *   - https://lh3.googleusercontent.com/d/FILE_ID[=w1000] (already-lh3)
 *
 * Any non-Drive URL is returned unchanged.
 */
export function normalizeImageUrl(raw, { width = 1600 } = {}) {
  if (!raw || typeof raw !== 'string') return raw;
  const url = raw.trim();
  if (!url) return url;

  // Already an lh3 link — ensure we don't break user-specified sizing
  if (url.includes('lh3.googleusercontent.com/')) return url;

  // Extract Drive FILE_ID from the common share URL formats
  // Pattern 1: /file/d/FILE_ID/
  let m = url.match(/\/file\/d\/([A-Za-z0-9_-]{10,})/);
  if (m) return `https://lh3.googleusercontent.com/d/${m[1]}=w${width}`;
  // Pattern 2: ?id=FILE_ID or &id=FILE_ID
  m = url.match(/[?&]id=([A-Za-z0-9_-]{10,})/);
  if (m && /drive\.google\.com|docs\.google\.com/.test(url)) {
    return `https://lh3.googleusercontent.com/d/${m[1]}=w${width}`;
  }

  return url;
}

/** Returns true when the given URL is (or can be converted into) a Drive-served image. */
export function isGoogleDriveUrl(raw) {
  if (!raw) return false;
  return /drive\.google\.com|lh3\.googleusercontent\.com|docs\.google\.com/i.test(raw);
}
